import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PersistState {
    chatWidth: number
    // Kept apart from chatWidth, so reopening restores the width the user dragged the panel to
    chatCollapsed: boolean
    // Only a collapse chosen where the sidebar opens by default; see useSidebarOpen
    sidebarCollapsed: boolean
    soundsEnabled: boolean
    // ISO 639-1 pair for live translation; the right one depends on the patient, so it is kept per browser only.
    liveTranslationLanguages: [string, string]
    setChatWidth: (width: number) => void
    setChatCollapsed: (collapsed: boolean) => void
    setSidebarCollapsed: (collapsed: boolean) => void
    setSoundsEnabled: (enabled: boolean) => void
    setLiveTranslationLanguages: (languages: [string, string]) => void
}

export const usePersistStore = create<PersistState>()(
    persist(
        (set) => ({
            chatWidth: 450,
            chatCollapsed: false,
            sidebarCollapsed: false,
            soundsEnabled: true,
            liveTranslationLanguages: ['nl', 'en'],
            setChatWidth: (width: number) => set({ chatWidth: width }),
            setChatCollapsed: (collapsed: boolean) => set({ chatCollapsed: collapsed }),
            setSidebarCollapsed: (collapsed: boolean) => set({ sidebarCollapsed: collapsed }),
            setSoundsEnabled: (enabled: boolean) => set({ soundsEnabled: enabled }),
            setLiveTranslationLanguages: (languages: [string, string]) => set({ liveTranslationLanguages: languages }),
        }),
        {
            name: 'medendo',
            version: 2,
            // v1 also stored _clickedTs (unread-row tracking, since removed) — drop it on upgrade.
            migrate: (persisted) => ({ chatWidth: (persisted as Partial<PersistState>)?.chatWidth ?? 450 }),
        }
    )
)
